import { Minus, Plus } from "lucide-react";
import { money } from "@/lib/api";

export const PartyStepper = ({ value, onChange, max = 20 }) => (
  <div className="flex items-center gap-4" data-testid="party-stepper">
    <button type="button" onClick={() => onChange(Math.max(1, value - 1))} disabled={value <= 1}
      className="flex h-11 w-11 rounded-full items-center justify-center border border-[#C9A24B]/50 text-[#D9B864] transition-colors hover:bg-[#C9A24B]/15 disabled:opacity-30"
      data-testid="party-decrease-button" aria-label="Fewer guests"><Minus className="h-4 w-4" /></button>
    <span className="min-w-[90px] text-center font-mono text-lg text-white" data-testid="party-count">{value} {value === 1 ? "guest" : "guests"}</span>
    <button type="button" onClick={() => onChange(Math.min(max, value + 1))} disabled={value >= max}
      className="flex h-11 w-11 rounded-full items-center justify-center border border-[#C9A24B]/50 text-[#D9B864] transition-colors hover:bg-[#C9A24B]/15 disabled:opacity-30"
      data-testid="party-increase-button" aria-label="More guests"><Plus className="h-4 w-4" /></button>
  </div>
);

export const OrderSummary = ({ ticket, qty, fee }) => {
  const subtotal = (ticket?.price || 0) * qty;
  return (
    <dl className="space-y-2 font-mono text-sm" data-testid="order-summary">
      <div className="flex justify-between text-[#BDB3A5]"><dt>{qty} × {money(ticket?.price)}</dt><dd data-testid="summary-subtotal">{money(subtotal)}</dd></div>
      <div className="flex justify-between text-[#BDB3A5]"><dt>Checkout service fee</dt><dd data-testid="summary-fee">{money(fee)}</dd></div>
      <div className="flex justify-between border-t border-white/15 pt-3 text-base text-white"><dt>Total</dt><dd className="text-[#D9B864]" data-testid="summary-total">{money(subtotal + fee)}</dd></div>
    </dl>
  );
};
